import InfoPanelContainer from './InfoPanelContainer';

export default InfoPanelContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/InfoPanel/index.js